import './MonitoringWhat.css'
import img from '../monitoringassets/whatimage.png';

export default function MonitoringWhat() {
  return (
    <div id='monitor-what' className='outsourcemainclass'>
<div className="left">
<h2>What Is Monitoring & Observability?</h2>
<div className="content">
  <p><strong>Monitoring</strong> focuses on tracking system metrics, logs, and alerts to identify issues.</p>
<p><strong>Observability</strong> goes a step further by providing deep insights into system behavior using metrics, logs, and traces—helping teams understand why issues occur and resolve them faster.</p>
<p>Together, monitoring and observability empower teams to maintain high-performing, resilient systems.</p>
</div>
</div>
<div className="right">
<img src={img} alt="error" />
</div>
    </div>
  )
}
